import React, { useEffect, useState } from 'react';
import { CarouselProps } from 'react-multi-carousel';
import Rating from 'atomic/rating';
import Price from 'atomic/price';
import NumberOfOffer from 'atomic/number-of-offer';
import WidgetRecommendationsProps from 'modules/shared/widgets/components/widget-recommendations/widget-recommendations.props';
import WidgetCarouselDesktopBasic from 'modules/shared/widgets/components/widget-carousel/widget-carousel-deskktop/components/widget-carousel-desktop-basic';
import WidgetRecommendationsCtaButton from '../components/widget-recommendations-cta-button/widget-recommendations-cta-button';
import OfferLabel from 'modules/shared/modules/product/components/offer-label';
import { getMonoOfferLabel } from 'helpers/offer-label';

import './widget-recommendations.desktop.scss';

const WidgetRecommendationsDesktop: React.FC<WidgetRecommendationsProps> = ({ config, data }) => {
    const [WidgetRecommendationsComponent, setWidgetCarousel] = useState<React.ComponentType<CarouselProps>>(() => WidgetCarouselDesktopBasic);
    const { items, category } = data;

    const numberOfItems = 4;

    useEffect(() => {
        import('react-multi-carousel').then(mod => {
            setWidgetCarousel(() => mod.default);
        });
    }, []);

    const responsive = {
        desktop: {
            breakpoint: { max: 5000, min: 0 },
            items: numberOfItems
        }
    };

    return (
        <div className="w-recommendations-d">
            <h2 className="w-recommendations-d__title" style={{ color: config.styles?.description?.color }}>
                Polecane przez klientów
            </h2>
            {config.description && (
                <div className="w-recommendations-d__description" style={{ color: config.styles?.description?.color }}>
                    {config.description}
                </div>
            )}
            <div className="w-recommendations-d__list">
                <WidgetRecommendationsComponent
                    responsive={responsive}
                    swipeable={false}
                    draggable={false}
                    slidesToSlide={numberOfItems}
                    renderButtonGroupOutside={true}
                    arrows={true}
                    autoPlay={config.autoPlay}
                    className="w-carousel-d__list"
                    itemClass={`w-carousel-d__list__item w-${numberOfItems}`}
                >
                    {items.map(product => {
                        const offerLabel = getMonoOfferLabel(product);

                        return (
                            <div key={product.id} className="w-recommendations-d__list__item-wrapper">
                                <div className="w-recommendations-d__list__item-wrapper__stars">
                                    <Rating size="sm" opinions={product.opinions} />
                                </div>
                                <a
                                    href={product.url}
                                    title={product.name}
                                    className="w-recommendations-d__list__item-content"
                                >
                                    <div className="w-recommendations-d__list__item-content__image">
                                        <img
                                            src={product.photo}
                                            alt={product.name}
                                            loading={config.lazyLoad ? 'lazy' : 'eager'}
                                            width={162}
                                            height={162}
                                        />
                                    </div>
                                    <div className="w-recommendations-d__list__item-content__title">
                                        {product.name}
                                    </div>
                                    <div className="w-recommendations-d__list__item-content__stars-placeholder" />
                                    <div className="w-recommendations-d__list__item-content__price">
                                        <span>od</span>
                                        <Price price={product.minPrice} weight={600} />
                                    </div>
                                    <div className="w-recommendations-d__list__item-content__number-of-offer">
                                        <NumberOfOffer offers={product.offers} />
                                    </div>
                                    <div className="w-recommendations-d__list__item-content__opinion">
                                        {product.opinions.items[0]?.content.length > 0 && (
                                            <div className="w-recommendations-d__list__item-content__opinion__text">
                                                {product.opinions.items[0]?.content}
                                            </div>
                                        )}
                                    </div>
                                </a>
                                {offerLabel && (
                                    <div className="w-recommendations-d__list__item-wrapper__label">
                                        <OfferLabel label={offerLabel} />
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </WidgetRecommendationsComponent>
            </div>
            {(category && config.cta) && (
                <WidgetRecommendationsCtaButton
                    id={category.id}
                    slug={category.slug}
                    color={config.styles?.cta?.color}
                    text={config.cta}
                />
            )}
        </div>
    );
};

export default WidgetRecommendationsDesktop;
